
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"clip-rule":"evenodd","d":"M28.75 38.75c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10z","stroke":"#666","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M25.625 26.875A3.125 3.125 0 1128.75 30m0 3.75a.625.625 0 110 1.25.625.625 0 010-1.25m-15 0h-10a2.5 2.5 0 01-2.5-2.5V3.75a2.5 2.5 0 012.5-2.5h17.715a2.5 2.5 0 011.767.732l4.786 4.786a2.5 2.5 0 01.732 1.767v5.215","stroke":"#666","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M8.75 9.375a.625.625 0 110 1.25.625.625 0 010-1.25m11.392 6.601L18.75 13.75a1.248 1.248 0 00-2.063-.024l-3.334 4.752-2.053-1.645a1.25 1.25 0 00-1.822.282L6.25 23.75h7.5","stroke":"#666","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    